import { render, staticRenderFns } from "./DialogIllness.vue?vue&type=template&id=62ed57f8&"
import script from "./DialogIllness.vue?vue&type=script&lang=js&"
export * from "./DialogIllness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports